var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 12C15.3335 13.6569 13.9904 15 12.3335 15C10.6766 15 9.3335 13.6569 9.3335 12C9.3335 10.3431 10.6766 9 12.3335 9C13.9904 9 15.3335 10.3431 15.3335 12Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2279 11.5528C20.0697 7.23635 16.2366 5 12.3335 5C8.43037 5 4.59729 7.23635 2.43907 11.5528C2.29831 11.8343 2.29831 12.1657 2.43907 12.4472C4.59729 16.7637 8.43037 19 12.3335 19C16.2366 19 20.0697 16.7637 22.2279 12.4472C22.3687 12.1657 22.3687 11.8343 22.2279 11.5528ZM12.3335 17C9.36471 17 6.33155 15.3792 4.46315 12C6.33155 8.62078 9.36471 7 12.3335 7C15.3023 7 18.3354 8.62078 20.2038 12C18.3354 15.3792 15.3023 17 12.3335 17Z",
    fill: "#6E6E6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1865efe88a10e12a9b0e224e9c888f77.svg";
export { ForwardRef as ReactComponent };